export const onXmapsData = {
    projectHeading: 'The onXmaps Project',
    projectMainImage: {
        image: '/images/portfolio/featured-portfolio.jpg',
        alt: 'onXmaps Portfolio Banner'
    },
    additionalImages: [
        {
            fullImage: '/images/portfolio/onxmaps/about.png',
            image: '/images/portfolio/onxmaps/about-thumb.png',
            alt: 'onXmaps About Page'
        },
        {
            fullImage: '/images/portfolio/onxmaps/dealers.jpg',
            image: '/images/portfolio/onxmaps/dealers-thumb.jpg',
            alt: 'onXmaps Dealer Asset Download Page'
        },
        {
            fullImage: '/images/portfolio/onxmaps/do.jpg',
            image: '/images/portfolio/onxmaps/do-thumb.jpg',
            alt: 'What We Do Page'
        },
        {
            fullImage: '/images/portfolio/onxmaps/government.jpg',
            image: '/images/portfolio/onxmaps/government-thumb.jpg',
            alt: 'onXmaps Government Page'
        },
        {
            fullImage: '/images/portfolio/onxmaps/lifestyles.jpg',
            image: '/images/portfolio/onxmaps/lifestyles-thumb.jpg',
            alt: 'onXmaps Lifestyles Page'
        },
        {
            fullImage: '/images/portfolio/onxmaps/redeem.jpg',
            image: '/images/portfolio/onxmaps/redeem-thumb.jpg',
            alt: 'onXmaps Redeem Gift Card Page'
        },
        {
            fullImage: '/images/portfolio/onxmaps/support.png',
            image: '/images/portfolio/onxmaps/support-thumb.png',
            alt: 'onXmaps Support Page'
        },
        {
            fullImage: '/images/portfolio/onxmaps/work-with.png',
            image: '/images/portfolio/onxmaps/work-with-thumb.png',
            alt: 'Work With onXmaps Page'
        }
    ],
    aboutHeading: 'About onXmaps',
    aboutPortfolioText: [
        `onXmaps is a digital mapping company, started by Eric Siegried a few years before I
         joined the team in the winter of 2012. At the time, the company was still
         a startup, with me being it's 12th employee. The company was primarily focused on
         making digital hunting maps, with the goal of expanding the business to encompass
         all 50 states in the US. As time went on, the company developed Android and Apple
         apps as new revenue avenues for income. New markets were explored, which brought
         about the creation of recreational outdoor maps (the ROAM product line).`,

        `onXmaps was originally known as Montana Mapping. When the
         decision was made to explore new markets, the company went through a rebranding.
         This rebranding led to the creation of their various websites/product platforms; of which I played a
         significant role. At the time when I left the company in 2016, the company had
         transitioned from a startup into a full company, boasting nearly 50 employees and had plans to continue growing
         as a leader in the Mapping industry.`
    ],
    websiteGoalsHeading: 'Website Goals',
    websiteGoalsText: [
        `The purpose of onXmaps.com was to serve as the umbrella site for the
         different product verticals of the company. The company had it&#39;s eyes set on massive
         growth, so it was important to develop a strong foundation for the company to expand upon. The website
         educated consumers on the various product verticals the company encompassed, with
         avenues for the consumer to explore the products on specific websites for purchase.
         `
    ],
    websiteGoalsListHeading: 'Website Goals List',
    websiteGoalsList: [
        `Give a high level overview of the company, and the mission of onXmaps`,
        `Allow government agencies a place to contact onXmaps to discuss working together`,
        `Allow dealers of various onXmaps product verticals a place to acquire marketing materials`,
        `Give a direct path for customers to find map products for their recreational needs`,
        `Serve as an outlet for various campaigns, such as redeeming gift cards for specific products`,
        `Be SEO friendly`,
        `Be responsive and fast (the homepage was 3GB with an initial paint time of under 1 sec)`,
        `Utilize modern technology, for easier maintenance`,
        `Allow tracking of user interaction for analying websites usage/viability`
    ],
    myRoleHeading: 'My Role With OnXmaps',
    position: 'Lead Web Developer',
    company: 'onXmaps Inc.',
    timeWithCompany: '3 years, 5 months',
    myRoleText: [
        `My position within onXmaps started out as a Jr. Web Designer,
         with the primary objective of maintaining the sole sight, huntinggpsmaps.com and
         improving the SEO. At the time, we were working with a third party web developer, Inchoo, whom had
         built the site on the Magento E-Commerce Platform (Community Edition). Shortly after I
         joined, Inchoo ended their contract with onXmaps. I quickly picked up the responsibilities for
         the development and maintenance of the website, and eventually became the lead web
         developer for all of the web platforms.
        `,

        `Part of the responsibility of being the lead web developer was managing our projects
         through a 3rd party development shop, called Web Solutions. I would have meetings with
         the marketing team, lay out projects (diagrams, mockups, etc.) for the third party team, and
         then oversee the project. I would also be developing other features in the code, and
         then would code review the work Web Solutions had done. In addition, I had trained and
         was overseeing the work of Jr. Web Developer as well. Needless to say, I was involved
         every part of the process in the web system.
        `
    ],
    jobSummaryIntro: 'Following is a summary of my responsibilities while at onXmaps',
    jobSummaryList: [
        `Build/Manage 2 Magento E-Commerce Websites`,
        `Build/Manage Company Umbrella Site, onXmaps`,
        `Build/Manage Internal Revenue Tracking Site`,
        `Train Junior Developers`,
        `Support Backend Infrastructure for Android and IOS Apps`,
        `Design and implement Database Schemas for MySQL`,
        `Design Web Pages using Illustrator and Photoshop`,
        `Development Web Pages (Full Stack)`,
        `Manage other developers with projects`,
        `Analyze Traffic to Improve E-Commerce Conversion Rates`,
        `Update SSL and Server Configurations through third <br/>party hosted dedicated server`,
        `Architect the data structures and technologies to use`,
        `Retrofit existing sites with Newer Technologies (like Sass)`,
        `Optimized sites for speed`,
        `Upgraded Magento platforms to latest versions (1.7 -> 1.9 Community Edition)`,
        `Converted fixed width websites to responsive`,
        `Utilized best practice SEO techniques in the web system`,
        `Run weekly meetings with marketing managers`,
        `Write requirements, design mockups, and facilitate projects with Third Party Web Development Contractors`
    ],
    technologiesUsedIntro: `This section contains the technologies used for building the onXmaps website. The site was
                        originally architected and built by myself, with mockups coming from the design
                        department.`,
    technologiesList: [
        `HTML5`,
        `Sass`,
        `CSS3`,
        `JavaScript`,
        `jQuery`,
        `Laravel 4x`,
        `AngularJS (1.5)`,
        `MailChimp Newsletter`,
        `Skrollr`,
        `UserVoice`,
        `Twitter Bootstrap`,
        `Responsive Design`,
        `PHP`,
        `Google Analytics`,
        `Red Hat Server`,
        `Git`,
        `Photoshop`,
        `Illustrator`
    ]
}